/**
 * Type-safe API module identifiers for configurable logging
 *
 * Each module can have its own log level configured in LoggerConfig
 */
export enum ApiModule {
  // Products
  ProductGet = 'api.product.get',
  ProductGetExpanded = 'api.product.getExpanded',
  ProductGetBase = 'api.product.getBase',
  ProductList = 'api.product.list',
  ProductVariantGet = 'api.productVariant.get',
  ProductVariantGetExpanded = 'api.productVariant.getExpanded',
  ProductVariantListByCodes = 'api.productVariant.listByCodes',
  ProductAttributeGroupsList = 'api.productAttributeGroups.list',

  // Orders
  OrderGet = 'api.order.get',
  OrderGetExpanded = 'api.order.getExpanded',
  OrderGetByIdentifier = 'api.order.getByIdentifier',
  OrderCreate = 'api.order.create',
  OrderUpdate = 'api.order.update',
  OrderComplete = 'api.order.complete',
  OrderList = 'api.order.list',
  OrderItemAdd = 'api.orderItem.add',
  OrderItemEdit = 'api.orderItem.edit',
  OrderItemDelete = 'api.orderItem.delete',
  OrderPaymentUpdate = 'api.orderPayment.update',
  OrderShippingUpdate = 'api.orderShipping.update',
  OrderShippingAndPaymentsList = 'api.orderShippingAndPayments.list',
  ShippingMethodList = 'api.shippingMethod.list',
  PaymentMethodList = 'api.paymentMethod.list',
  CountryList = 'api.country.list',
  PaymentRequestCreate = 'api.paymentRequest.create',
  PaymentRequestGet = 'api.paymentRequest.get',
  PaymentRequestCheck = 'api.paymentRequest.check',

  // Categories (Taxons)
  CategoryGet = 'api.category.get',
  CategoryListRootMenu = 'api.category.listRootMenu',
  TaxonListTree = 'api.taxon.listTree',

  // Brands
  BrandGet = 'api.brand.get',
  BrandList = 'api.brand.list',
  BrandListAlphabet = 'api.brand.listAlphabet',

  // Search
  SearchSuggest = 'api.search.suggest',
  SearchFacets = 'api.search.facets',
  SearchPickerFacets = 'api.search.pickerFacets',
  SearchProducts = 'api.search.products',

  // Articles (Blog)
  ArticleGet = 'api.article.get',
  ArticleList = 'api.article.list',
  ArticleListFavourite = 'api.article.listFavourite',
  ArticleAuthorsList = 'api.articleAuthors.list',
  ArticleCategoriesList = 'api.articleCategories.list',
  ArticleTagsList = 'api.articleTags.list',
  ArticleSectionsList = 'api.articleSections.list',

  // Customer
  CustomerGet = 'api.customer.get',
  CustomerCreate = 'api.customer.create',
  CustomerUpdate = 'api.customer.update',
  CustomerTokenCreate = 'api.customer.tokenCreate',
  CustomerPasswordReset = 'api.customer.passwordReset',
  CustomerPasswordResetWithToken = 'api.customer.passwordResetWithToken',
  CustomerPasswordUpdate = 'api.customer.passwordUpdate',
  CustomerContactUs = 'api.customer.contactUs',
  CustomerTokenRefresh = 'api.customer.tokenRefresh',
  CustomerNewsletterSubscribe = 'api.customer.newsletterSubscribe',
  CustomerMeGet = 'api.customer.meGet',
  CustomerVerify = 'api.customer.verify',

  // Product Favourite Lists
  ProductFavouriteListList = 'api.productFavouriteList.list',
  ProductFavouriteListCreate = 'api.productFavouriteList.create',
  ProductFavouriteListDelete = 'api.productFavouriteList.delete',
  ProductFavouriteListProductsAdd = 'api.productFavouriteList.addProducts',
  ProductFavouriteListProductsDelete = 'api.productFavouriteList.deleteProducts',
  ProductFavouriteListGetProducts = 'api.productFavouriteList.getProducts',

  // Address
  AddressCreate = 'api.address.create',
  AddressUpdate = 'api.address.update',

  // Favourites
  FavouritesListsGet = 'api.favourites.listsGet',
  FavouritesProductsGet = 'api.favourites.productsGet',
  FavouritesListCreate = 'api.favourites.listCreate',
  FavouritesListRename = 'api.favourites.listRename',
  FavouritesListDelete = 'api.favourites.listDelete',
  FavouritesProductAdd = 'api.favourites.productAdd',
  FavouritesProductRemove = 'api.favourites.productRemove',

  // CMS
  PageGet = 'api.page.get',
  BannerList = 'api.banner.list',
  HomepageGet = 'api.homepage.get',

  // App Router
  AppRouter = 'api.appRouter',

  // Alert Messages
  AlertMessagesList = 'api.alertMessages.list',

  // FAQ
  FaqTopicList = 'api.faqTopic.list',
  FaqTopicGet = 'api.faqTopic.get',
  FaqQuestionGet = 'api.faqQuestion.get',

  // Glossary
  GlossaryTermList = 'api.glossaryTerm.list',
  GlossaryTermGet = 'api.glossaryTerm.get',
  GlossaryAlphabetGet = 'api.glossaryAlphabet.get',
}
